import { DealStatus, SweepOptions } from 'components/common/types/Deal.types';
import { getFramesListData, getUploadedFramesFileData } from 'utils/framesUtils';
import { NonMediaServiceStatus } from 'components/common/types/NonMediaServices.types';

export const getCodes = (list) => list.map((item) => item.code);
export const getCodesWithMediaOwner = (list, environmentId) =>
  list.map((item) => ({ code: item.code, mediaOwner: item.mediaOwner || environmentId }));

export const getListData = (routeFrameCodes, listFiles) => {
  const { incFrameList, excFrameList } = getFramesListData(routeFrameCodes);
  const { incFileList, excFileList } = getUploadedFramesFileData(listFiles);

  const includeFrames = [...incFrameList, ...incFileList];
  const excludeFrames = [...excFrameList, ...excFileList];

  return {
    ...(includeFrames.length ? { includeFrames } : {}),
    ...(excludeFrames.length ? { excludeFrames } : {}),
  };
};

export const getPgDistributionTypeFromSweep = (sweep) => {
  if (!sweep || sweep === SweepOptions.NONE) {
    return undefined;
  }

  if (sweep === SweepOptions.SWEEP_FLOOR_TO_CEILING_RANGE) {
    return SweepOptions.SWEEP_TO_FILL;
  }

  return sweep;
};

export const getTargetData = ({ impressions, budget, sot, sweep, frames, ceilingSot = null, floorSot = null }) => {
  const pgDistributionType = getPgDistributionTypeFromSweep(sweep);

  return {
    ...(impressions ? { impressions } : {}),
    ...(budget ? { budget } : {}),
    ...(frames ? { frames } : {}),
    ...(sot ? { sot } : {}),
    ...(ceilingSot ? { ceilingSot } : {}),
    ...(floorSot ? { floorSot } : {}),
    ...(pgDistributionType ? { pgDistributionType } : {}),
  };
};

export const getFilesOfCurrentLine = (currentLine) => [...currentLine.listFiles, ...currentLine.visualUnitFiles];

export const getFilesToUpload = (files = []) => {
  const filesToUpload = {};

  files.forEach(({ name, fileId, file }) => {
    if (fileId || !file) return;
    filesToUpload[name] = file;
  });

  return filesToUpload;
};

export const transformBookingStatusCode = (bookingStatusCode) => {
  switch (bookingStatusCode) {
    case DealStatus.LIVE:
    case DealStatus.APPROVED:
      return 'CONFIRMED';
    case DealStatus.CANCELLED:
      return 'CANCEL';
    default:
      return bookingStatusCode;
  }
};

const mapServicesToPayload = (services) => {
  return services.map((service) => ({
    measurementCode: service.measurement.code,
    eligibilityRule: service?.eligibilityRuleId,
    pricingConfig: service?.pricingConfigId,
    contacts: service?.contactEmails,
  }));
};

export const transformLineServices = ({ services, isNewLine, areServicesChanged }) => {
  if (!services?.length || !areServicesChanged) return null;

  if (isNewLine) return mapServicesToPayload(services);

  const deletedServices = services
    .filter((service) => service.status === NonMediaServiceStatus.REQUESTED_CANCELLATION)
    .map((service) => service?.activationId);

  const addedServices = services.filter((service) => service.status === NonMediaServiceStatus.SELECTED);

  return {
    removeActivationIds: deletedServices,
    newActivations: mapServicesToPayload(addedServices),
  };
};
